import React from "react";
import { Image, StyleSheet, TouchableWithoutFeedback } from "react-native";
import colors from "../config/colors";
// import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
// import colors from '../config/colors';

function HeaderRightButton({ onPress }) {
  return (
    // <MaterialCommunityIcons
    //   name="home"
    //   size={30}
    //   color="white"
    //   onPress={onPress}
    //   style={styles.icon}
    // />
    <TouchableWithoutFeedback onPress={onPress}>
      <Image
        source={require("../assets/home_icon.png")}
        style={{
          height: 30,
          width: 30,
          marginRight: 10,
          tintColor: colors.primary,
          // resizeMode: "contain",
        }}
      />
    </TouchableWithoutFeedback>
  );
}

const styles = StyleSheet.create({
  icon: { marginRight: 10 },
});

export default HeaderRightButton;
